(function () {
  if (window.headerVehicleFilterInitialized) return;
  window.headerVehicleFilterInitialized = true;

  var CM_SEARCH_URL = "https://oewholesale1.myconvermax.com/search.json";

  var yearSelect, makeSelect, modelSelect, submitButton, clearButton;

  function buildFacetUrl(fields) {
    var url = new URL(CM_SEARCH_URL);
    url.searchParams.set("pagesize", "0");

    fields.forEach(function (field, index) {
      url.searchParams.set("facet." + index + ".field", field.name);
      if (field.selection) {
        url.searchParams.set("facet." + index + ".selection", field.selection);
      }
    });

    return url.toString();
  }

  function findFacet(facets, fieldName) {
    return (facets || []).find(function (facet) {
      return facet.FieldName === fieldName;
    });
  }

  function clearSelect(select, placeholder) {
    select.innerHTML = "";

    var option = document.createElement("option");
    option.className = "default";
    option.value = "";
    option.selected = true;
    option.disabled = true;
    option.textContent = placeholder;
    select.appendChild(option);
  }

  function disableSelect(select, placeholder) {
    clearSelect(select, placeholder);
    select.disabled = true;
    select.closest(".form-group").classList.add("disabled");
  }

  function enableSelect(select) {
    select.disabled = false;
    select.closest(".form-group").classList.remove("disabled");
  }

  function populateSelect(select, values) {
    values.forEach(function (value) {
      var option = document.createElement("option");
      option.value = value.Value;
      option.textContent = value.Value;
      option.dataset.term = value.Term || value.Value;
      select.appendChild(option);
    });
  }

  function updateSubmitState() {
    // The submit + clear buttons are shared across all three header tabs.
    // Only manage them while the Vehicle tab is active; the Size/Part tabs are
    // managed by header-size-filter.js.
    var vehicleTab = document.getElementById("header-filter-tab-vehicle");
    if (vehicleTab && !vehicleTab.classList.contains("is-active")) return;
    var hasAllFields = !!(yearSelect.value && makeSelect.value && modelSelect.value);
    if (submitButton) submitButton.disabled = !hasAllFields;
  }

  function setSelectValueByTerm(select, term) {
    var match = Array.prototype.slice.call(select.options).find(function (option) {
      return option.dataset.term === term;
    });
    if (!match) return false;

    select.value = match.value;
    return true;
  }

  function getSelectedVehicle() {
    var yearTerm = yearSelect.selectedOptions[0] && yearSelect.selectedOptions[0].dataset.term;
    var makeTerm = makeSelect.selectedOptions[0] && makeSelect.selectedOptions[0].dataset.term;
    var modelTerm = modelSelect.selectedOptions[0] && modelSelect.selectedOptions[0].dataset.term;
    if (!yearTerm || !makeTerm || !modelTerm) return null;
    return { year: yearTerm, make: makeTerm, model: modelTerm };
  }

  var VEHICLE_STORAGE_KEY = "cm_selected_vehicle";

  function persistVehicle(vehicle) {
    try {
      localStorage.setItem(VEHICLE_STORAGE_KEY, JSON.stringify(vehicle));
    } catch (e) {}
  }

  function loadPersistedVehicle() {
    try {
      var raw = localStorage.getItem(VEHICLE_STORAGE_KEY);
      if (!raw) return null;

      var vehicle = JSON.parse(raw);
      if (!vehicle || !vehicle.year || !vehicle.make || !vehicle.model) return null;
      return vehicle;
    } catch (e) {
      return null;
    }
  }

  function clearPersistedVehicle() {
    try {
      localStorage.removeItem(VEHICLE_STORAGE_KEY);
    } catch (e) {}
  }

  function parseVehicleFromUrl() {
    var raw = window.location.search.replace(/^\?/, "");
    if (!raw) return null;

    var segments = raw.split("/").map(decodeURIComponent);
    var vehicle = {};

    segments.forEach(function (segment, index) {
      if (segment === "Year") vehicle.year = segments[index + 1];
      if (segment === "Make") vehicle.make = segments[index + 1];
      if (segment === "Model") vehicle.model = segments[index + 1];
    });

    if (!vehicle.year || !vehicle.make || !vehicle.model) return null;
    return vehicle;
  }

  function loadYears(pending) {
    fetch(buildFacetUrl([{ name: "Year" }]))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var facet = findFacet(data.Facets, "Year");
        if (!facet) return;

        clearSelect(yearSelect, "Year");
        populateSelect(yearSelect, facet.Values);
        enableSelect(yearSelect);

        if (pending && pending.year && setSelectValueByTerm(yearSelect, pending.year)) {
          loadMakes(yearSelect.value, pending);
        }
      })
      .catch(function () {});
  }

  function loadMakes(year, pending) {
    disableSelect(makeSelect, "Make");
    disableSelect(modelSelect, "Model");
    updateSubmitState();

    fetch(buildFacetUrl([{ name: "Year", selection: year }, { name: "Make" }]))
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var facet = findFacet(data.Facets, "Make");
        if (!facet) return;

        clearSelect(makeSelect, "Make");
        populateSelect(makeSelect, facet.Values);
        enableSelect(makeSelect);

        if (pending && pending.make && setSelectValueByTerm(makeSelect, pending.make)) {
          loadModels(year, makeSelect.value, pending);
        }
      })
      .catch(function () {});
  }

  function loadModels(year, make, pending) {
    disableSelect(modelSelect, "Model");
    updateSubmitState();

    fetch(
      buildFacetUrl([
        { name: "Year", selection: year },
        { name: "Make", selection: make },
        { name: "Model" },
      ])
    )
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        var facet = findFacet(data.Facets, "Model");
        if (!facet) return;

        clearSelect(modelSelect, "Model");
        populateSelect(modelSelect, facet.Values);
        enableSelect(modelSelect);

        if (pending && pending.model && setSelectValueByTerm(modelSelect, pending.model)) {
          updateSubmitState();
        }
      })
      .catch(function () {});
  }

  function onYearChange() {
    updateSubmitState();
    if (!yearSelect.value) return;
    loadMakes(yearSelect.value);
  }

  function onMakeChange() {
    updateSubmitState();
    if (!makeSelect.value) return;
    loadModels(yearSelect.value, makeSelect.value);
  }

  function onModelChange() {
    updateSubmitState();
  }

  function isProductPage() {
    return document.body.classList.contains("template-product");
  }

  function onSubmit(event) {
    var vehicleTab = document.getElementById("header-filter-tab-vehicle");
    if (!vehicleTab || !vehicleTab.classList.contains("is-active")) return;

    event.preventDefault();

    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;
    if (!year || !make || !model) return;

    var yearTerm = yearSelect.selectedOptions[0].dataset.term;
    var makeTerm = makeSelect.selectedOptions[0].dataset.term;
    var modelTerm = modelSelect.selectedOptions[0].dataset.term;

    var fitmentPath =
      "Fitment/Vehicle-Specific/Year/" +
      encodeURIComponent(yearTerm) +
      "/Make/" +
      encodeURIComponent(makeTerm) +
      "/Model/" +
      encodeURIComponent(modelTerm);

    persistVehicle({ year: yearTerm, make: makeTerm, model: modelTerm });

    if (isProductPage()) {
      window.history.pushState({}, "", window.location.pathname + "?" + fitmentPath);

      document.dispatchEvent(
        new CustomEvent("cm:vehicle-changed", {
          detail: { year: yearTerm, make: makeTerm, model: modelTerm },
        })
      );
      return;
    }

    window.location = "/pages/search?" + fitmentPath;
  }

  function init() {
    yearSelect = document.getElementById("header-filter-year");
    makeSelect = document.getElementById("header-filter-make");
    modelSelect = document.getElementById("header-filter-model");
    submitButton = document.querySelector(".header-scroll-filters-submit");
    clearButton = document.getElementById("header-vehicle-clear");

    var form = document.querySelector(".header-scroll-filters-form");
    var vehicleTab = document.getElementById("header-filter-tab-vehicle");
    if (!yearSelect || !makeSelect || !modelSelect || !form || !vehicleTab) return;

    yearSelect.addEventListener("change", onYearChange);
    makeSelect.addEventListener("change", onMakeChange);
    modelSelect.addEventListener("change", onModelChange);
    form.addEventListener("submit", onSubmit);
    vehicleTab.addEventListener("click", updateSubmitState);
    // The Clear button is now shared across all three tabs and handled centrally
    // in section-filters.js (onClear).

    document.addEventListener("cm:open-vehicle-picker", function () {
      if (!vehicleTab.classList.contains("is-active")) {
        vehicleTab.click();
      }
      vehicleTab.scrollIntoView({ behavior: "smooth", block: "center" });
    });

    document.addEventListener("cm:vehicle-changed", function (event) {
      var vehicle = event.detail;
      if (!vehicle) return;

      var current = getSelectedVehicle();
      if (
        current &&
        current.year === vehicle.year &&
        current.make === vehicle.make &&
        current.model === vehicle.model
      ) {
        return;
      }

      loadYears(vehicle);
    });

    loadYears(parseVehicleFromUrl() || loadPersistedVehicle());
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
